import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 129 129",
    class: "minut-svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill="#193446" d="M73.519 82.282H89.45a17.967 17.967 0 0014.178-6.979 17.156 17.156 0 003.564-8.648 17.877 17.877 0 00-4.322-14.178 17.55 17.55 0 00-13.42-6.151H73.52a2.914 2.914 0 00-2.957 2.957 2.962 2.962 0 002.957 2.957H89.45a12.063 12.063 0 010 24.122H73.52a2.963 2.963 0 00-2.957 2.949 2.913 2.913 0 002.957 2.971z"/> <path fill="#193446" d="M83.23 61.345H46.21v5.917H83.23v-5.917z"/> <path fill="#193446" d="M55.922 46.325H39.99A18.229 18.229 0 0027.26 51.56a18.228 18.228 0 00-5.246 12.742A17.97 17.97 0 0039.99 82.28h15.93a2.96 2.96 0 002.96-2.969 3.26 3.26 0 00-.833-2.123 2.979 2.979 0 00-2.123-.834H39.99a12.063 12.063 0 010-24.122h15.93a2.959 2.959 0 000-5.917v.011z"/>' }
  })
);